'use client'

import { Accordion, AccordionDetails, AccordionSummary } from '@mui/material'
import { useMemo } from 'react'

const ProgramSectionAccordion = ({ sections }) => {
  const safeSections = useMemo(
    () => (Array.isArray(sections) ? sections : []),
    [sections]
  )

  if (safeSections.length === 0) {
    return null
  }

  return (
    <div className="tw:sm:max-w-[70%] tw:w-full tw:mx-auto tw:mt-8">
      {safeSections.map((section, index) => {
        const sectionId = section?.id || `section-${index}`
        const titleHtml = section?.title || 'Untitled Section'
        const contentHtml = section?.content || ''

        return (
          <Accordion
            disableGutters
            key={sectionId}
            defaultExpanded={false}
            className="tw:shadow-sm tw:rounded-lg"
          >
            <AccordionSummary
              expandIcon={<i className="far fa-chevron-down tw:text-primary" />}
              aria-controls={`${sectionId}-content`}
              id={`${sectionId}-header`}
              className="tw:bg-neutral-50 tw:px-4 tw:py-3 tw:rounded-t-lg"
            >
              <h3
                className="tw:font-semibold tw:tracking-wider tw:text-sm md:tw:text-base"
                dangerouslySetInnerHTML={{ __html: titleHtml }}
              />
            </AccordionSummary>
            <AccordionDetails className="tw:bg-white tw:px-4 tw:py-4 tw:rounded-b-lg">
              <div
                className="wp-content"
                dangerouslySetInnerHTML={{ __html: contentHtml }}
              />
            </AccordionDetails>
          </Accordion>
        )
      })}
    </div>
  )
}

export default ProgramSectionAccordion
